import {createContext} from 'react'

export type ScreenSizeCtx = {
  screenWidth: number | undefined
  screenHeight: number | undefined
  screenSizeUpdate: number
}

export const ScreenSizeContext = createContext<ScreenSizeCtx>({
  screenWidth: undefined,
  screenHeight: undefined,
  screenSizeUpdate: 0,
})
